import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'ew-mat-dialog-custom',
  templateUrl: './mat-dialog-custom.component.html',
  styleUrls: ['./mat-dialog-custom.component.scss'],
})
export class MatDialogCustomComponent {
  @Input() urlHelp!: string;
  constructor(public dialogRef: MatDialogRef<MatDialogCustomComponent>) { }
}
